import { any, object } from 'prop-types';
import React from 'react';

import { Link, Text } from '@sitecore-jss/sitecore-jss-react';

const TradeInSpecialRewardsItem = ({ item, buyNowLink, buyNowText }) => {
  return ( 
    <>
      <div className='item'>
        <div className='item__content'>
          <Link className='item__content__link' field={{ href: item?.['Url']}}>
            <img src={item?.['Image']} />
          </Link>
          <h3 className='item__content__title'>
            <Link className='item__content__title__name' field={{ href: item?.['Url']}}>
              <Text field={{ value: item?.['ProductName'] }} />
            </Link>
          </h3>
          <div className='item__content__price'>
            {/** Always show two price */}
            {/* {item?.['Price']?.SellingPrice <= item?.['Price']?.ListPrice ? (
              <> */}
            <Text className='item__content__price__text item__content__price__text--new' tag='p' field={{ value: item?.['Price']?.SellingPriceWithCurrency }} />
            <Text tag='del' className='item__content__price__text item__content__price__text--cost' field={{ value: item?.['Price']?.ListPriceWithCurrency }} />
            {/* </>
            ) : (
              <>
                <Text tag='p' field={{ value: item?.['Price']?.ListPriceWithCurrency }} />
                <></>
              </>
            )} */}
          </div>
        </div>
        <div className='item__btn'>
          <Link field={{ href: `${buyNowLink}?productPageId=${item?.Id}&isLoyalty=${true}`}} className='item__button btn btn-primary'>
            <Text field={buyNowText} />
          </Link>
        </div>
      </div>
    </>
  );
};

TradeInSpecialRewardsItem.propTypes = {
  item: object,
  buyNowLink: any,
  buyNowText: any
};
 
export default TradeInSpecialRewardsItem;